import React, { useContext, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Container,
} from "@mui/material";
import searchIcon from "../assets/majesticons_search-line.png";
import { Menu as MenuIcon, AccountCircle } from "@mui/icons-material";
import filterIcon from "../assets/svg/Frame 3465955.svg";
import arrowBackIcon from "../assets/svg/ic_round-arrow-back.svg";
import { useLocation, useNavigate } from "react-router-dom";
import PostWalkInDialog from "../shared/dialog/PostWalkInDialog";
import { FunctionContext } from "../context/FunctionProvider";
import HeaderButtons from "../shared/header/HeaderButtons";
import NavButtons from "../shared/header/NavButtons";
import MobileDrawer from "../shared/header/MobileDrawer";
import { path } from "../constant";
const Header = ({ mobileflag }) => {
  const navigate = useNavigate();
  const { searchSubmit, t } = useContext(FunctionContext);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openPostWalkInDialog, setOpenPostWalkInDialog] = useState(false);

  const location = useLocation();
  const currentUrl = location.pathname;
  // console.log(currentUrl);
  const { customBreakpoints } = useContext(FunctionContext);
  const menuItems = [
    {
      lable: t("walkin"),
      click: () => {
        searchSubmit({});
      },
    },
    { lable: t("about")      , click: () => {
      navigate(path.aboutus)
    },},
    { lable: t("contact") ,click: () => {
      navigate(path.contactus)
    }},
    
  ];
  const handleDrawerOpen = (value) => {
    setDrawerOpen(value);
  };
  return (
    <>
      <MobileDrawer
        drawerOpen={drawerOpen}
        handleDrawerOpen={handleDrawerOpen}
        customBreakpoints={customBreakpoints}
        setOpenPostWalkInDialog={setOpenPostWalkInDialog}
        menuItems={menuItems}
        currentUrl={currentUrl}
      />
      <AppBar position="fixed " sx={{ bgcolor: "white", color: "black" }}>
        <Toolbar sx={{ height: "10vh", width: "100%" }} disableGutters>
          <Container fixed>
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              width={"100%"}
            >
              {(currentUrl === "/search" || currentUrl === "/walkin") &&
              mobileflag ? (
                <>
                  <img
                    alt=""
                    src={arrowBackIcon}
                    onClick={() => navigate(-1)}
                    // sx={{ fontSize: "55px", color: "grey" }}
                  />
                  <div className="search_input ">
                    <input
                      className="b-none"
                      placeholder={t("searchforjob")}
                    ></input>
                    <img
                      src={searchIcon}
                      className="search-image"
                      alt="search"
                    ></img>
                  </div>
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <img
                      alt=""
                      src={filterIcon}
                      onClick={() => handleDrawerOpen(true)}
                      // sx={{ fontSize: "55px", color: "grey" }}
                    />
                  </span>
                </>
              ) : (
                <>
                  {" "}
                  <Typography
                    onClick={() => navigate("/")}
                    sx={{ alignContent: "center" }}
                    variant="h3"
                    className="walknow walknow-head"
                  >
                    {" "}
                    {t("walknowlogo")}
                  </Typography>
                  {customBreakpoints.isMobile ||
                  customBreakpoints.isDeviceDown ? (
                    <>
                      <Box display={"flex"} alignItems={"center"}>
                        <IconButton
                          size="large"
                          aria-label="menu"
                          aria-controls="menu-appbar"
                          aria-haspopup="true"
                          onClick={() => handleDrawerOpen(true)}
                          color="inherit"
                        >
                          {currentUrl === "/walkin" ? (
                            <span
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <img
                                alt=""
                                src={filterIcon}
                                onClick={() => handleDrawerOpen(true)}
                                // sx={{ fontSize: "55px", color: "grey" }}
                              />
                            </span>
                          ) : (
                            <MenuIcon />
                          )}
                        </IconButton>{" "}
                      </Box>{" "}
                    </>
                  ) : (
                    <>
                      <Box
                        display={"flex"}
                        justifyContent={"center"}
                        width={"50%"}
                        gap={8}
                        alignItems={"center"}
                      >
                        <NavButtons
                          isMobileFlag={
                            customBreakpoints.isMobile ||
                            customBreakpoints.isDeviceDown
                          }
                          menuItems={menuItems}
                        />
                      </Box>
                      <Box display={"flex"} alignItems={"center"}>
                        {/* Right Buttons (Desktop View) */}
                        <Box
                          sx={{ display: { xs: "none", md: "flex" }, gap: 2 }}
                        >
                          {/* currentUrl === "/search" ||
                          currentUrl === "/walkin" ?  */}
                          {false?
                          (
                            <>
                              <div className="search_input ">
                                <input
                                  className="b-none"
                                  placeholder={t("searchforjob")}
                                ></input>
                                <img
                                  src={searchIcon}
                                  className="search-image"
                                  alt="search"
                                ></img>
                              </div>
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <AccountCircle
                                  sx={{ fontSize: "55px", color: "grey" }}
                                />
                              </span>
                            </>
                          ) 
                          : (
                            <HeaderButtons
                              setOpenPostWalkInDialog={setOpenPostWalkInDialog}
                            />
                          )}
                        </Box>
                      </Box>
                    </>
                  )}
                </>
              )}
            </Box>
          </Container>
        </Toolbar>
      </AppBar>
      <PostWalkInDialog
        openPostWalkInDialog={openPostWalkInDialog}
        setOpenPostWalkInDialog={setOpenPostWalkInDialog}
      />
    </>
  );
};

export default Header;
